(ns frontend.view.nev.kyc.process.data-enrichment
  (:require
   [common.localization :as loc]
   [common.schema.entities.workspace.kyc.kyc-utils :as kyc-utils]
   [frontend.actions.kyc-process :as kyc-process-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.notification.view :as notification-modal]
   [ui.components.button.view :as button]))

(defn open-notification!
  [type title msg lang-kw]
  (modals/open-modal!
   notification-modal/modal-key
   {:title          title
    :body-text      msg
    :ok-button-text (loc/tr :ok nil lang-kw)}))

(defn handle-address-info [{:keys [response state-atom answers-atom
                                   loading-atom lang-kw save!]}]
  (let [address (-> response
                    :body
                    :address)
        legal-entity-address {:kyc-legal-entity/city     (:city address)
                              :kyc-legal-entity/address  (:visiting_address address)
                              :kyc-legal-entity/zip-code (:postal address)
                              :kyc-legal-entity/country  (keyword (:country address))}]
    (swap! state-atom assoc
           :kyc-process/answers
           (merge
            @answers-atom
            legal-entity-address))
    (->> legal-entity-address
         (map (fn [[key value]]
                (swap! answers-atom assoc key value)
                (swap! loading-atom assoc-in [:attributes-to-refresh key] true)))
         (doall))

    (open-notification! :success
                        (loc/tr :data-found nil lang-kw)
                        (loc/tr :address-data-found nil lang-kw)
                        lang-kw)
    (save!)))

(defn handle-board-member-data [{:keys [response answers-atom state-atom lang-kw save!]}]
  (let [board-members-from-enrichment (-> response
                                          :body
                                          :board-members)
        existing-board-members (get @answers-atom :kyc-legal-entity/board-members-edn)]
    (if (seq board-members-from-enrichment)
      (let [resolved-board-members (kyc-utils/resolve-board-members-from-enrichment
                                    board-members-from-enrichment
                                    existing-board-members)]
        (swap! state-atom assoc-in
               [:kyc-process/answers :kyc-legal-entity/board-members-edn]
               resolved-board-members)
        (open-notification!
         :success
         (loc/tr :data-found nil lang-kw)
         (loc/tr :board-members-found [(count board-members-from-enrichment)] lang-kw)
         lang-kw)
        (save!))
      (open-notification! :error
                          (loc/tr :data-not-found nil lang-kw)
                          (loc/tr :board-members-not-found nil lang-kw)
                          lang-kw))))

(defn handle-data-enrichment-response
  [{:keys [response section-kw state-atom answers-atom save! lang-kw loading-atom]}]
  (let [error? (-> response
                   :body
                   :error)]
    (if error?
      (open-notification! :error
                          (loc/tr :data-not-found nil lang-kw)
                          (loc/tr :data-not-found-check-business-id-and-country nil lang-kw)
                          lang-kw)
      (condp = section-kw

        :kyc.legal-entity/address-information
        (handle-address-info {:response     response
                              :state-atom   state-atom
                              :answers-atom answers-atom
                              :loading-atom loading-atom
                              :lang-kw      lang-kw
                              :save!        save!})

        :kyc-legal-entity/board-member-data
        (handle-board-member-data {:response     response
                                   :state-atom   state-atom
                                   :answers-atom answers-atom
                                   :lang-kw      lang-kw
                                   :save!        save!})
        nil))))

(defn data-enrichment-button
  [{:keys [section-kw kyc-process state-atom answers-atom loading-atom lang-kw save!]}]
  (let [kyc-process-draft-status? (= (:kyc-process/status kyc-process) :kyc-process.status/draft)
        business-id (:kyc-legal-entity/business-id @answers-atom)
        country-of-origin (:kyc-legal-entity/jurisdiction @answers-atom)
        valid-country? (some #{:FI :SE :DK :NO :IS} [country-of-origin])
        valid-data? (and business-id valid-country?)
        ;; TODO too much coupling with service provider - more generic
        ;; feature-key is preferable now that changing from Vainu to Zefram
        has-kyc-enrichment-feature? (session/has-feature-access? :feature/enrichment-vainu)
        show-button? (and
                      kyc-process-draft-status?
                      has-kyc-enrichment-feature?
                      (some #{section-kw}
                            [:kyc.legal-entity/address-information
                             :kyc-legal-entity/board-member-data]))
        button-copy (condp = section-kw
                      :kyc.legal-entity/address-information (loc/tr :enrich-address-data nil lang-kw)
                      :kyc-legal-entity/board-member-data (loc/tr :enrich-board-member-data nil lang-kw)
                      "")
        loading-data? (and loading-atom (get @loading-atom section-kw))
        enrich-data (fn []
                      (let [enrich-action-type
                            (condp = section-kw
                              :kyc.legal-entity/address-information :kyc-enrichment/get-company-address
                              :kyc-legal-entity/board-member-data :kyc-enrichment/get-board-members
                              nil)
                            request-data (condp = section-kw
                                           :kyc.legal-entity/address-information
                                           {:business-id business-id :country country-of-origin}

                                           :kyc-legal-entity/board-member-data
                                           {:business-id business-id :country country-of-origin}
                                           nil)]
                        (if enrich-action-type
                          (do
                            (swap! loading-atom assoc section-kw true)
                            (kyc-process-actions/*->enrich-data!
                             enrich-action-type
                             request-data
                             (fn [response]
                               (swap! loading-atom dissoc section-kw)
                               (handle-data-enrichment-response {:response     response
                                                                 :section-kw   section-kw
                                                                 :kyc-process  kyc-process
                                                                 :answers-atom answers-atom
                                                                 :state-atom   state-atom
                                                                 :save!        save!
                                                                 :lang-kw      lang-kw
                                                                 :loading-atom loading-atom}))
                             (fn [response]
                               (swap! loading-atom dissoc section-kw)
                               (open-notification! :error
                                                   (loc/tr :error nil lang-kw)
                                                   (loc/tr :error-something-went-wrong nil lang-kw)
                                                   lang-kw)
                               (logging/error "Failed to get enrichment data " response))))
                          (logging/error "Unknown data enrich action type " enrich-action-type))))]
    (when show-button?
      [:li.mb-3.px-3
       [button/primary-solid
        {:disabled? (or loading-data?
                        (not valid-data?))
         :tooltip   (cond
                      (or (not business-id) (not country-of-origin))
                      (loc/tr :check-business-id-and-country-tooltip nil lang-kw)
                      (not valid-country?)
                      (loc/tr :data-enrichment-not-available-for-country nil lang-kw))
         :on-click  enrich-data}
        (if loading-data?
          (loc/tr :loading-indicator nil lang-kw)
          (str button-copy))]])))
